mutation UpsertCategory (
    $id: ID
    $definition: CategoryDefinition!
) {
    upsertCategory(
        id: $id
        definition: $definition
    ) {
        errors {
            message
            path
        }
        category {
            id
            name {
                language
                text
            }
            icon
        }
    }
}
